import { useEffect } from 'react';

import './Uboard.css'
import Sboard from './sboard';

function Uboard(props) {

  // console.log('uboard');
  // console.log(props);

  useEffect(
    () => {
      setBoardSize();

      window.addEventListener('resize', setBoardSize);

      return () => window.removeEventListener('resize', setBoardSize);
    },
    [],
  );

  let currentRepresentation = props.currentRepresentation;
  let lastMove = props.lastMove;
  let onClickAction = props.onClickAction;
  let allAllowedClassName = props.allAllowedClassName;
  let currentBigRepresentation = props.currentBigRepresentation;
  let boardElements = [];

  for (let p = 0; p < 3; p++) {
    for (let q = 0; q < 3; q++) {
      let lm = null;
      if (lastMove && p === lastMove[0] && q === lastMove[1]) {
        lm = [lastMove[2], lastMove[3]];
      }
      let isAllowedClassName = null;
      if (!allAllowedClassName && lastMove && p === lastMove[2] && q === lastMove[3]) {
        if (currentRepresentation[lastMove[0]][lastMove[1]][lastMove[2]][lastMove[3]] === 'X') {
          isAllowedClassName = 'is-allowed-O';
        }
        if (currentRepresentation[lastMove[0]][lastMove[1]][lastMove[2]][lastMove[3]] === 'O') {
          isAllowedClassName = 'is-allowed-X';
        }
      }
      let elm = <div key={`u${p}${q}`} className={`u${p}${q}`}>
        <Sboard currentRepresentation={currentRepresentation[p][q]} lastMove={lm} onClickAction={onClickAction} ub={[p,q]} isAllowedClassName={isAllowedClassName} bigResultDisplay={currentBigRepresentation[p][q]} />
      </div>;

      boardElements.push(elm);
    }
  }

  return (
    <div className="Uboard">
      <div className={`uboard-container ${allAllowedClassName}`}>
        {boardElements}
      </div>
    </div>
  );

}


export default Uboard;


function setBoardSize() {
  let displayWidth = Math.min(
    document.body.scrollWidth, document.documentElement.scrollWidth,
    document.body.offsetWidth, document.documentElement.offsetWidth,
    document.body.clientWidth, document.documentElement.clientWidth
  );
  let mysize = displayWidth;
  if (mysize >= 500) {
    mysize = 500
  }

  let uSize = mysize * .9;

  let sSize = (uSize / 3) * .9;

  let squareSize = (sSize / 3);

  let uboard = document.querySelector('.uboard-container');
  uboard.style.width = uboard.style.height = uSize + 'px';

  let sboards = document.querySelectorAll('.uboard-container .sboard-container');
  let sresults = document.querySelectorAll('.sboard-result');
  for (let sboard of sboards) {
    sboard.style.width = sboard.style.height = sSize + 'px';
  }
  for (let sresult of sresults) {
    sresult.style.width = sresult.style.height = sSize*.7 + 'px';
  }

  let squares = document.querySelectorAll('.uboard-container .sboard-container > div');
  for (let square of squares) {
    square.style.width = square.style.height = squareSize + 'px';
  }

}